<app-modal [open]="active" [name]="'review-order-submitted'" (close)="closeDialog()">
  <div modal-header>{{ title }} Submitted For Review.</div>
  <div modal-body class="submission-summary">
    <div class="submission-summary__item">
      <p class="submission-summary__label">Service Type</p>
      <p class="submission-summary__value">
        {{ siteSubType ? siteType + " - " + siteSubType : siteType }}
      </p>
    </div>
    <div class="submission-summary__item">
      <p class="submission-summary__label">Location</p>
      <p class="submission-summary__value">
        <span *ngIf="address?.streetAddress"
          >{{ address?.streetAddress }}<br
        /></span>
        {{ address?.cityStateZip }}
      </p>
    </div>
  </div>
  <button
    modal-footer
    type="button"
    class="btn btn--primary"
    data-testid="review-order-submitted-close"
    (click)="closeDialog()"
  >
    OK
  </button>
</app-modal>
